<div class="row" *ngIf="order">
    <div class="col-lg-3">
        <div class="consumption-numbers">
            <div class="number">{{order?.hoursGlobal}} ({{(order?.hoursGlobal / 8).toFixed(2) }}d)</div>
            <div class="title">{{'order.budget.summary.hoursGlobal' | translate | uppercase }}</div>
        </div>
        <div class="consumption-numbers">
            <div class="number">{{order?.hoursAssigned}} ({{(order?.hoursAssigned / 8).toFixed(2) }}d)</div>
            <div class="title">{{'order.budget.summary.hoursAssigned' | translate | uppercase }}</div>
        </div>
        <div class="consumption-numbers">
            <div class="number"> {{order?.hoursResidual}} ({{(order?.hoursResidual / 8).toFixed(2) }}d)</div>
            <div class="title">{{'order.budget.summary.hoursResidual' | translate | uppercase }}</div>
        </div>
    </div>
    <div class="col-lg-9">
        <njo-budget-product-allocation-chart [data]="chartData" [totalSpent]="totalSpent"
            [totalHoursAssigned]="order.hoursGlobal"></njo-budget-product-allocation-chart>
    </div>
</div>
<table *ngIf="order">
    <caption style="display: none;">Product allocation table</caption>
    <tr>
        <td colspan="6" style="text-align: center; font-size: 18px;"><img src="assets/img/alarm-clock.png" class="alarm-clock" alt="exhausted products" />AVAILABLE PRODUCTS</td>
    </tr>
    <tr>
        <th style="text-align: left;" scope="col">{{'order.budget.summary.productName' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.code' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.hoursGlobal' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.hoursAssigned' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.hoursResidual' | translate }}</th>
        <th style="text-align: left;"  scope="col">{{'order.budget.summary.progress' | translate }}</th>
    </tr>
    <tr class="available-products" *ngFor="let product of productsWithHoursAssigned">
        <td>{{product.name}}</td>
        <td>{{product.code}}</td>
        <td>{{product.hoursGlobal}} ({{(product.hoursGlobal / 8).toFixed(2) }}d)</td>
        <td>{{product.hoursAssigned}} ({{(product.hoursAssigned / 8).toFixed(2) }}d)</td>
        <td>{{product.hoursResidual}} ({{(product.hoursResidual / 8).toFixed(2) }}d)</td>
        <td>
            <progress-bar [progress]="(product.hoursAssigned / product.hoursGlobal) * 100" [disable-percentage]="true"
                class="progress-form">
            </progress-bar>
        </td>
    </tr>
    <tr>
        <td colspan="6" style="text-align: center; font-size: 18px;"><img src="assets/img/alarm-clock-alert.png" class="alarm-clock" alt="exhausted products" />EXHAUSTED PRODUCTS</td>
    </tr>
    <tr>
        <th style="text-align: left;" scope="col">{{'order.budget.summary.productName' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.code' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.hoursGlobal' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.hoursAssigned' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.hoursResidual' | translate }}</th>
        <th  scope="col">{{'order.budget.summary.progress' | translate }}</th>
    </tr>
    <tr class="not-available-products" *ngFor="let product of productsWithoutHoursAssigned">
        <td>{{product.name}}</td>
        <td>{{product.code}}</td>
        <td>{{product.hoursGlobal}} ({{(product.hoursGlobal / 8).toFixed(2) }}d)</td>
        <td>{{product.hoursAssigned}} ({{(product.hoursAssigned / 8).toFixed(2) }}d)</td>
        <td>{{product.hoursResidual}} ({{(product.hoursResidual / 8).toFixed(2) }}d)</td>
        <td>
            <progress-bar [progress]="(product.hoursResidual / product.hoursGlobal) * 100" [disable-percentage]="true"
                class="progress-form">
            </progress-bar>
        </td>
    </tr>

</table>